<div class="table-actions-wrapper">
    <h3 class="mt-0 mb-12">{{ 'GENERAL.LABEL.USER_ROLE' | translate }}</h3>
    <div class="w-100-p table-wrapper" *ngIf="dataSource">
        <span id="ruler" class="ruler"></span>

        <mat-table #table [dataSource]="dataSource" matSort>
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="pl-24 pr-8" *matHeaderCellDef></mat-header-cell>

                <mat-cell #nameCell *matCellDef="let userType" class="pl-24 pr-8" fxLayout="column" fxLayoutAlign="center start">
                    <span class="text-truncate font-semibold w-100-p">{{ userType.translationKey | translate }}</span>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>

                <mat-cell *matCellDef="let userType">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button
                            [label]="'GENERAL.BUTTON.ADD'"
                            (onClick)="addToList(userType); onSelection()"
                            *ngIf="!userType.selected"
                            [disabled]="isRoleAddedToList"
                        ></app-flat-button>

                        <app-white-button
                            [label]="'GENERAL.BUTTON.UNSELECT'"
                            (onClick)="removeFromList(userType); onSelection()"
                            *ngIf="userType.selected"
                        ></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row *matRowDef="let userType; columns: displayedColumns" matRipple> </mat-row>
        </mat-table>
    </div>
</div>
